import red from '@material-ui/core/colors/red'
import cyan from '@material-ui/core/colors/cyan'
const options: any = {
  palette: {
    primary: red,
    secondary: cyan
  }
}

export default options



// WEBPACK FOOTER //
// ./src/theme.ts